import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入主页面
import Home from '@/views/Home/index.vue'
import AboutUs from '@/views/AboutUs/index.vue'
import CourseSystem from '@/views/CourseSystem/index.vue'
import Competition from '@/views/Competition/index.vue'
import JoinUs from '@/views/JoinUs/index.vue'
import News from '@/views/News/index.vue'
import ContactUs from '@/views/ContactUs/index.vue'
// 引入子页面
import SubNews from '@/views/subpages/sub_news/index.vue'
import SubJoin from '@/views/subpages/sub_join/index.vue'

// 引入401、404页面
import Unauthorized from '@/views/401.vue'
import NotFound from '@/views/404.vue'

Vue.use(VueRouter)

// 添加辅助函数 isMobile，用于判断当前设备是否为手机
function isMobile() {
  return window.innerWidth < 768;  // 这里的阈值可以根据需求调整
}

const routes = [
  // 主页面路由
  // 首页路由（精确匹配）
  {
    path: '/',
    name: 'Home',
    component: isMobile()
      ? () => import('@/views/mobile_views/Home/index.vue') // 手机端首页路由
      : Home,
    caseSensitive: false,
    meta: { title: '首页 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // 关于我们路由（精确匹配）
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: isMobile()
      ? () => import('@/views/mobile_views/AboutUs/index.vue') // 手机端关于我们路由
      : () => import('@/views/AboutUs/index.vue'),
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '关于我们 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // 课程体系路由（精确匹配）
  {
    path: '/CourseSystem',
    name: 'CourseSystem',
    component: isMobile()
      ? () => import('@/views/mobile_views/CourseSystem/index.vue') // 手机端课程体系路由
      : CourseSystem,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '课程体系 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // 白名单赛事路由（精确匹配）
  {
    path: '/Competition',
    name: 'Competition',
    component: isMobile()
      ? () => import('@/views/mobile_views/Competition/index.vue') // 手机端白名单赛事路由
      : Competition,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '白名单赛事 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // 全国加盟路由（精确匹配）
  {
    path: '/JoinUs',
    name: 'JoinUs',
    component: isMobile()
      ? () => import('@/views/mobile_views/JoinUs/index.vue') // 手机端全国加盟路由
      : JoinUs ,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '全国加盟 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // 新闻中心路由（精确匹配）
  {
    path: '/News',
    name: 'News',
    // component: isMobile()
    //   ? () => import('@/views/mobile_views/News/index.vue') // 手机端新闻中心路由
    //   : News,
    component: isMobile()? () => import('@/views/mobile_views/News/index.vue')
        : () => import('@/views/News/index.vue'),
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '新闻中心 - 蓝悦教育', layout: 'default', keepAlive: true },
  },
  // 联系我们路由（精确匹配）
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: isMobile()
      ? () => import('@/views/mobile_views/ContactUs/index.vue') // 手机端联系我们路由
      : ContactUs,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '关于我们 - 蓝悦教育', layout: 'default', keepAlive: false },
  },

  // 子页面路由
  // Sub新闻路由（精确匹配）
  {
    path: '/News/info/:documentId',
    name: 'SubNews',
    component: isMobile()
      ? () => import('@/views/mobile_views/SubPages/sub_news/index.vue') // 手机端Sub新闻路由
      : SubNews,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '新闻中心 - 蓝悦教育', layout: 'default', keepAlive: false },
  },
  // Sub加盟路由（精确匹配）
  {
    path: '/JoinUs/info',
    name: 'SubJoin',
    component: isMobile()
      ? () => import('@/views/mobile_views/SubPages/sub_join/index.vue') // 手机端Sub加盟路由
      : SubJoin,
    caseSensitive: false, // 大小写敏感配置
    meta: { title: '全国加盟 - 蓝悦教育', layout: 'default', keepAlive: false },
  },

  // 重定向路由（可选）
  // 显式定义 401 路由
  {
    path: '/401',
    name: 'Unauthorized',
    component: isMobile()
      ? () => import('@/views/mobile_views/401.vue') // 手机端重定向401路由
      : Unauthorized,
    meta: { title: '401 - 蓝悦教育', layout: 'empty', keepAlive: false },
  },
  // 显式定义 404 路由（可选）
  {
    path: '/404',
    name: 'NotFound',
    component: isMobile()
      ? () => import('@/views/mobile_views/404.vue') // 手机端重定向404路由
      : NotFound,
    meta: { title: '404 - 蓝悦教育', layout: 'empty', keepAlive: false },
  },

  // 通配符路由（必须放在最后）
  {
    path: '*', // 匹配所有未定义路径
    redirect: '/404', // redirect: isMobile() ? '/mobile404' : '/404'
  }
]

const router = new VueRouter({
  mode: 'hash', // 临时改为 hash 模式排除服务器问题
  // mode: 'history', // todo: 若用 history 模式需配置服务器
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    // console.log(to.path)
    // console.log(from.path)
    // console.log(to.params.documentId)
    // console.log(from.params.documentId)

    // if(to.path === from.path){
    //   return false;
    // }

    if (
        to.path.startsWith('/News/info/') &&
        from.path.startsWith('/News/info/') &&
        to.params.documentId !== from.params.documentId
    ) {
      return false; // 保持当前位置
    }

    if (to.path === from.path && to.path.startsWith('/News') && from.path.startsWith('/News')) {
      return false; // 保持当前位置
    }
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  }

})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 替换页面标题
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
  // if (!to.path.startsWith("/News/info/")) {
  //     document.title = to.meta.title
  // }
  // 为每个路由添加 isMobile 属性，用于判断当前设备是否为手机
  Vue.prototype.$isMobile = window.innerWidth < 768;
  next();
});

export default router